const t = {
  name: "Menu",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 4H22V6H2V4Z" fill="currentColor"/>
<path d="M2 11V13H22V11H2Z" fill="currentColor"/>
<path d="M22 18H2V20H22V18Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Menu
};
